import {css} from 'lit';

import {defaultStyles} from '../../../components/code.js';

export const styles = defaultStyles.extends({
  statics: css``,
});

export default {styles};
